
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const FilmIcon =  ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    {...restProps}>
    <path
      fill={fill}
className={`dark:${
        isActive
          ? "fill-primary"
          : "fill-caption group-hover:dark:fill-primary"
      }`}
      fillRule="evenodd"
      d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm4 0H4v2h2V5Zm2 0v6h8V5H8Zm10 0v2h2V5h-2Zm2 4h-2v2h2V9Zm0 4h-2v2h2v-2Zm0 4h-2v2h2v-2Zm-4 2v-6H8v6h8ZM6 19v-2H4v2h2Zm-2-4h2v-2H4v2Zm0-4h2V9H4v2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default FilmIcon;
